// extracted by mini-css-extract-plugin
export default {"button":"PaginationButtons_button__iDnbf","status":"PaginationButtons_status__gu4gp","prev":"PaginationButtons_prev__W9-j7","next":"PaginationButtons_next__U7prq"};